import { store } from "../store/store";

export const getUpdatedList = ({ list, date, total, app, site, slug }) => {
  if (list.length > 0) {
    const activeSite = store.getters.getSite;
    const updatedList = list.map((item, idx) =>
      item.id === Number(app) && site === activeSite
        ? {
            pingDate: date,
            total,
            id: item.id,
            name: item.name,
            isChange: date !== item.date,
            isComplate: item.isComplate
          }
        : item
    );
    return updatedList;
  }

  return [];
};



// WEBPACK FOOTER //
// ./src/utils/common.js